import React from 'react'
import ImageSlide from '../components/Slide/ImageSlide';
import Message from '../components/Message/Message';
import Subsidiaries from '../components/Subsidiaries/Subsidiaries';

const Home = () => {

    return (
        <>
            < ImageSlide />
            < Message />
            < Subsidiaries />
      </>
  )
}

export default Home